import { render } from "./PostDisplay.vue?vue&type=template&id=4db17848&scoped=true&ts=true"
import script from "./PostDisplay.vue?vue&type=script&lang=ts"
export * from "./PostDisplay.vue?vue&type=script&lang=ts"

import "./PostDisplay.vue?vue&type=style&index=0&id=4db17848&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db17848"]])

export default __exports__